import {useEffect, useState} from "react";

function SpriteLoader() {
  const [sprite, setSprite] = useState("");

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/sprite.svg`)
      .then(res => res.text())
      .then(setSprite);
  }, []);

  return (
    <div
      style={{position: "absolute", width: 0, height: 0, overflow: "hidden"}}
      dangerouslySetInnerHTML={{__html: sprite}}
    />
  );
}

export default SpriteLoader;
